module.exports = __webpack_public_path__ + "static/img/5.21f9260.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/5.jpg
// module id = RxOv
// module chunks = 1